/* =============================================================
   JMM Header — comportements
   Statut agences en direct, machine à écrire, indicateur de nav,
   méga-menu univers, CTA magnétique, sticky verre dépoli,
   entrée en cascade, chiffres rouleurs, drawer mobile.
   ============================================================= */
(function () {
  'use strict';

  /* L'initialisation est ré-exécutable : l'éditeur de thème Shopify
     recharge la section (shopify:section:load) et remplace le DOM,
     ce qui perdait tous les écouteurs (burger mobile mort, etc.). */
  function initJmhHeader() {

  var header = document.querySelector('.jmh-header:not([data-jmh-init])');
  if (!header) return;
  header.setAttribute('data-jmh-init', '1');

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Entrée en cascade ---------- */
  function entrance() {
    var els = header.querySelectorAll('.jmh-st');
    els.forEach(function (el, i) { el.style.setProperty('--jmh-d', i); });
    header.classList.add('is-entered');
    window.setTimeout(function () {
      header.classList.add('jmh-anim-done');
    }, els.length * 70 + 700);
  }
  if (header.hasAttribute('data-entrance') && !reduceMotion) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', entrance);
    } else { entrance(); }
  } else {
    header.classList.add('is-entered');
    header.classList.add('jmh-anim-done');
  }

  /* ---------- Statut agences en direct ---------- */
  function parseTime(str) {
    if (!str) return null;
    var m = String(str).trim().match(/^(\d{1,2})[h:.](\d{2})$/) || String(str).trim().match(/^(\d{1,2})$/);
    if (!m) return null;
    return parseInt(m[1], 10) * 60 + (m[2] ? parseInt(m[2], 10) : 0);
  }
  function fmtTime(mins) {
    var h = Math.floor(mins / 60), m = mins % 60;
    return h + 'h' + (m < 10 ? '0' + m : m);
  }
  var statusEls = document.querySelectorAll('[data-jmh-status]');
  function updateStatus() {
    statusEls.forEach(function (el) {
      var days = (el.getAttribute('data-days') || '1,2,3,4,5').split(',').map(function (d) { return parseInt(d, 10); });
      var openAm = parseTime(el.getAttribute('data-open-am'));
      var closeAm = parseTime(el.getAttribute('data-close-am'));
      var openPm = parseTime(el.getAttribute('data-open-pm'));
      var closePm = parseTime(el.getAttribute('data-close-pm'));
      var prefix = el.getAttribute('data-prefix') || '';
      var dot = el.querySelector('.jmh-dot');
      var txt = el.querySelector('[data-jmh-status-text]');
      if (openAm === null || closePm === null) return;

      var now = new Date();
      var day = now.getDay();
      var mins = now.getHours() * 60 + now.getMinutes();
      var isWorkday = days.indexOf(day) !== -1;
      var inAm = closeAm !== null && mins >= openAm && mins < closeAm;
      var inPm = openPm !== null && mins >= openPm && mins < closePm;
      var noBreak = closeAm === null || openPm === null;
      var inDay = noBreak ? (mins >= openAm && mins < closePm) : (inAm || inPm);

      var state, label;
      if (isWorkday && inDay) {
        var close = noBreak ? closePm : (inAm ? closeAm : closePm);
        if (close - mins <= 60) { state = 'soon'; label = 'Ferme bientôt · à ' + fmtTime(close); }
        else { state = 'open'; label = 'Ouvert · ferme à ' + fmtTime(close); }
      } else {
        state = 'closed';
        var reopen;
        if (isWorkday && mins < openAm) { reopen = 'réouvre à ' + fmtTime(openAm); }
        else if (isWorkday && !noBreak && mins >= closeAm && mins < openPm) { reopen = 'réouvre à ' + fmtTime(openPm); }
        else {
          var next = (day + 1) % 7, hops = 1;
          while (days.indexOf(next) === -1 && hops < 8) { next = (next + 1) % 7; hops++; }
          var names = ['dimanche', 'lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi'];
          reopen = 'réouvre ' + (hops === 1 ? 'demain' : names[next]) + ' à ' + fmtTime(openAm);
        }
        label = 'Fermé · ' + reopen;
      }
      if (dot) dot.className = 'jmh-dot jmh-dot--' + state;
      if (txt) txt.textContent = label;
      el.setAttribute('data-state', state);
    });
    /* Miroirs du statut (footer) : copient l'état du statut principal */
    var clones = document.querySelectorAll('[data-jmh-status-clone]');
    if (statusEls.length && clones.length) {
      var srcState = statusEls[0].getAttribute('data-state') || 'open';
      var srcTxt = statusEls[0].querySelector('[data-jmh-status-text]');
      clones.forEach(function (c) {
        var cd = c.querySelector('.jmf-dot');
        if (cd) cd.className = 'jmf-dot' + (srcState === 'open' ? '' : ' jmf-dot--' + srcState);
        var ct = c.querySelector('[data-jmh-status-clone-text]');
        if (ct && srcTxt) ct.textContent = srcTxt.textContent;
      });
    }
    var agences = document.querySelectorAll('[data-jmh-agence-status]');
    var main = statusEls[0];
    if (main && agences.length) {
      var st = main.getAttribute('data-state') || 'open';
      agences.forEach(function (a) {
        var open = st !== 'closed';
        a.innerHTML = '<span class="jmh-dot jmh-dot--' + (open ? 'open' : 'closed') + '"></span>' + (open ? 'Ouvert' : 'Fermé');
        a.style.color = open ? '#4c9a2a' : '#c0392b';
      });
    }
  }
  if (statusEls.length) { updateStatus(); setInterval(updateStatus, 30000); }

  /* ---------- Chiffres rouleurs ---------- */
  document.querySelectorAll('[data-jmh-rolling]').forEach(function (el) {
    var text = el.textContent.trim();
    el.setAttribute('aria-label', text);
    el.innerHTML = text.split('').map(function (c, i) {
      if (c === ' ') return '<span style="width:.4rem"></span>';
      return '<span class="jmh-digit" aria-hidden="true"><span style="transition-delay:' + (i * 25) + 'ms">' + c + '</span><span style="transition-delay:' + (i * 25) + 'ms">' + c + '</span></span>';
    }).join('');
  });

  /* ---------- Machine à écrire (placeholder recherche) ---------- */
  var tw = header.querySelector('[data-jmh-typewriter]');
  if (tw && !reduceMotion) {
    var phrases = [];
    try { phrases = JSON.parse(tw.getAttribute('data-phrases') || '[]'); } catch (e) { phrases = []; }
    phrases = phrases.filter(function (p) { return p && p.trim(); });
    if (phrases.length) {
      var pi = 0, ci = 0, deleting = false;
      setInterval(function () {
        if (document.activeElement === tw || tw.value) return;
        var word = phrases[pi];
        if (!deleting) { ci++; if (ci === word.length + 8) deleting = true; }
        else { ci--; if (ci === 0) { deleting = false; pi = (pi + 1) % phrases.length; } }
        tw.setAttribute('placeholder', word.slice(0, Math.min(ci, word.length)) + (ci % 2 ? '|' : ''));
      }, 90);
    }
  } else if (tw) {
    try {
      var ph = JSON.parse(tw.getAttribute('data-phrases') || '[]');
      if (ph[0]) tw.setAttribute('placeholder', ph[0]);
    } catch (e) { /* noop */ }
  }

  /* ---------- Indicateur de navigation ---------- */
  var nav = header.querySelector('.jmh-nav');
  var indicator = header.querySelector('.jmh-nav__indicator');
  if (nav && indicator) {
    var links = nav.querySelectorAll('.jmh-nav__link');
    var activeLink = nav.querySelector('.jmh-nav__link--active') || links[0];
    function moveTo(el) {
      if (!el) return;
      indicator.style.left = el.offsetLeft + 'px';
      indicator.style.width = el.offsetWidth + 'px';
    }
    window.setTimeout(function () { moveTo(activeLink); }, 600);
    links.forEach(function (l) { l.addEventListener('mouseenter', function () { moveTo(l); }); });
    nav.addEventListener('mouseleave', function () { moveTo(activeLink); });
    window.addEventListener('resize', function () { moveTo(activeLink); });
  }

  /* ---------- Méga-menu univers ---------- */
  var mega = header.querySelector('.jmh-mega');
  var megaTrigger = header.querySelector('[data-jmh-mega-trigger]');
  var closeTimer = null;

  function openMega() {
    if (!mega) return;
    window.clearTimeout(closeTimer);
    if (!mega.classList.contains('is-open')) {
      mega.classList.add('is-open');
      if (megaTrigger) megaTrigger.setAttribute('aria-expanded', 'true');
      var active = mega.querySelector('.jmh-rail__item.is-active') || mega.querySelector('.jmh-rail__item');
      if (active) showUnivers(active, true);
    }
  }
  function closeMega(delay) {
    if (!mega) return;
    window.clearTimeout(closeTimer);
    closeTimer = window.setTimeout(function () {
      mega.classList.remove('is-open');
      if (megaTrigger) megaTrigger.setAttribute('aria-expanded', 'false');
    }, delay === undefined ? 150 : delay);
  }
  if (mega && megaTrigger) {
    megaTrigger.addEventListener('mouseenter', openMega);
    megaTrigger.addEventListener('focus', openMega);
    megaTrigger.addEventListener('click', function (e) {
      e.preventDefault();
      mega.classList.contains('is-open') ? closeMega(0) : openMega();
    });
    megaTrigger.addEventListener('mouseleave', function () { closeMega(); });
    mega.addEventListener('mouseenter', function () { window.clearTimeout(closeTimer); });
    mega.addEventListener('mouseleave', function () { closeMega(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeMega(0); });
    document.addEventListener('click', function (e) {
      if (mega.classList.contains('is-open') && !mega.contains(e.target) && e.target !== megaTrigger) closeMega(0);
    });
  }

  var railItems = mega ? mega.querySelectorAll('.jmh-rail__item') : [];
  var catsPanels = mega ? mega.querySelectorAll('[data-jmh-cats]') : [];
  var pvCard = mega ? mega.querySelector('.jmh-preview__card') : null;
  var pvImg = mega ? mega.querySelector('.jmh-preview__img') : null;
  var pvKicker = mega ? mega.querySelector('.jmh-preview__kicker') : null;
  var pvTitle = mega ? mega.querySelector('.jmh-preview__title') : null;
  var pvSub = mega ? mega.querySelector('.jmh-preview__sub') : null;
  var pvCta = mega ? mega.querySelector('.jmh-preview__cta') : null;

  function swapPreview(kicker, title, sub, img, url) {
    if (!pvCard) return;
    pvCard.classList.add('is-swapping');
    window.setTimeout(function () {
      if (pvKicker) pvKicker.textContent = kicker;
      if (pvTitle) pvTitle.textContent = title;
      if (pvSub) pvSub.textContent = sub || '';
      if (pvImg && img && pvImg.getAttribute('src') !== img) pvImg.setAttribute('src', img);
      if (pvCta && url) pvCta.setAttribute('href', url);
      pvCard.classList.remove('is-swapping');
    }, reduceMotion ? 0 : 180);
  }

  function cascade(panel) {
    if (reduceMotion) return;
    panel.querySelectorAll('.jmh-tile').forEach(function (t, i) {
      t.classList.add('is-entering');
      window.setTimeout(function () { t.classList.remove('is-entering'); }, 35 * i + 40);
    });
  }

  function showUnivers(item, force) {
    if (item.classList.contains('is-active') && !force) return;
    railItems.forEach(function (r) { r.classList.remove('is-active'); });
    item.classList.add('is-active');
    var id = item.getAttribute('data-univers');
    catsPanels.forEach(function (p) {
      var match = p.getAttribute('data-jmh-cats') === id;
      p.hidden = !match;
      if (match) cascade(p);
    });
    swapPreview(
      item.getAttribute('data-kicker') || 'Univers',
      item.getAttribute('data-title') || '',
      item.getAttribute('data-sub') || '',
      item.getAttribute('data-img') || '',
      item.getAttribute('data-url') || '#'
    );
  }
  railItems.forEach(function (item) {
    item.addEventListener('mouseenter', function () { showUnivers(item); });
    item.addEventListener('focus', function () { showUnivers(item); });
    item.addEventListener('click', function () {
      var url = item.getAttribute('data-url');
      if (url && url !== '#') window.location.href = url;
    });
  });
  if (mega) {
    mega.querySelectorAll('.jmh-tile').forEach(function (tile) {
      tile.addEventListener('mouseenter', function () {
        var rail = mega.querySelector('.jmh-rail__item.is-active');
        swapPreview(
          'Catégorie',
          tile.getAttribute('data-title') || tile.textContent.trim(),
          rail ? "Dans l'univers " + (rail.getAttribute('data-title') || '') : '',
          tile.getAttribute('data-img') || (rail ? rail.getAttribute('data-img') : ''),
          tile.getAttribute('href')
        );
      });
    });
  }

  /* ---------- Module En direct ---------- */
  var live = header.querySelector('[data-jmh-live]');
  if (live) {
    var liveWin = live.querySelector('.jmh-live__win');
    var liveProg = live.querySelector('.jmh-live__prog');
    var pool = Array.prototype.filter.call(liveWin.querySelectorAll('.jmh-live__msg'), function (m) {
      return !m.hasAttribute('hidden');
    });

    var weatherEl = liveWin.querySelector('[data-jmh-weather]');
    if (weatherEl) {
      var fbLat = weatherEl.getAttribute('data-lat'), fbLon = weatherEl.getAttribute('data-lon');
      var fbCity = weatherEl.getAttribute('data-city') || '';
      var loadWeather = function (lat, lon, city) {
        fetch('https://api.open-meteo.com/v1/forecast?latitude=' + encodeURIComponent(lat) + '&longitude=' + encodeURIComponent(lon) + '&current=temperature_2m,weather_code')
          .then(function (r) { return r.ok ? r.json() : Promise.reject(); })
          .then(function (d) {
            if (!d.current) return;
            var t = Math.round(d.current.temperature_2m);
            var code = d.current.weather_code;
            var icon, phrase;
            if (code <= 1) { icon = '☀️'; phrase = 'plein soleil sur les chantiers'; }
            else if (code <= 3) { icon = '⛅'; phrase = 'temps de chantier idéal'; }
            else if (code <= 48) { icon = '🌫️'; phrase = 'brouillard — prudence sur la route'; }
            else if (code <= 67 || (code >= 80 && code <= 82)) { icon = '🌧️'; phrase = 'pluie — pensez pompes et déshumidificateurs'; }
            else if (code <= 77 || (code >= 85 && code <= 86)) { icon = '❄️'; phrase = 'neige sur les chantiers'; }
            else { icon = '⛈️'; phrase = 'orage — prudence en hauteur'; }
            /* Les températures extrêmes priment sur la phrase météo (hors pluie/neige/orage) */
            if (code <= 48) {
              if (t >= 34) { icon = '🥵'; phrase = 'forte chaleur — hydratez les équipes'; }
              else if (t >= 30) { phrase = 'grosse chaleur sur les chantiers'; }
              else if (t <= 0) { icon = '🧊'; phrase = 'gel — prudence au démarrage des machines'; }
              else if (t <= 5) { phrase = 'ça pique au démarrage des machines'; }
            }
            weatherEl.querySelector('[data-jmh-weather-text]').textContent = icon + ' ' + t + '°C à ' + city + ' — ' + phrase;
            weatherEl.removeAttribute('hidden');
            pool.push(weatherEl);
            if (!liveWin.querySelector('.jmh-live__msg.is-on')) weatherEl.classList.add('is-on');
            if (typeof fitLive === 'function') fitLive();
          })
          .catch(function () { /* météo indisponible : message ignoré */ });
      };
      if (weatherEl.getAttribute('data-mode') === 'visitor') {
        /* Ville estimée par IP (GeoJS : gratuit, HTTPS, sans clé ni cookie).
           En cas d'échec ou de réponse incomplète : repli sur la ville fixe. */
        fetch('https://get.geojs.io/v1/ip/geo.json')
          .then(function (r) { return r.ok ? r.json() : Promise.reject(); })
          .then(function (g) {
            if (g && g.latitude && g.longitude && g.city) loadWeather(g.latitude, g.longitude, g.city);
            else loadWeather(fbLat, fbLon, fbCity);
          })
          .catch(function () { loadWeather(fbLat, fbLon, fbCity); });
      } else {
        loadWeather(fbLat, fbLon, fbCity);
      }
    }

    if (!liveWin.querySelector('.jmh-live__msg.is-on') && pool.length) pool[0].classList.add('is-on');

    /* La fenêtre s'ajuste à la largeur du plus long message (pas de vide à droite) */
    var fitLive = function () {
      var w = 0;
      pool.forEach(function (m) { w = Math.max(w, m.offsetWidth); });
      if (w > 0) liveWin.style.setProperty('--jmh-live-w', (w + 2) + 'px');
    };
    fitLive();
    window.addEventListener('resize', fitLive);

    if (!reduceMotion) {
      var liveSpeed = (parseInt(live.getAttribute('data-speed'), 10) || 10) * 1000;
      var liveIdx = 0, livePaused = false, liveT0 = performance.now(), liveElapsed = 0;
      live.addEventListener('mouseenter', function () { livePaused = true; });
      live.addEventListener('mouseleave', function () { livePaused = false; liveT0 = performance.now() - liveElapsed; });
      var liveTick = function (now) {
        if (!livePaused && pool.length > 1) {
          liveElapsed = now - liveT0;
          if (liveElapsed >= liveSpeed) {
            var cur = pool[liveIdx];
            cur.classList.remove('is-on');
            cur.classList.add('is-out');
            liveIdx = (liveIdx + 1) % pool.length;
            var next = pool[liveIdx];
            next.classList.remove('is-out');
            window.requestAnimationFrame(function () {
              window.requestAnimationFrame(function () { next.classList.add('is-on'); });
            });
            window.setTimeout(function () { cur.classList.remove('is-out'); }, 450);
            liveT0 = now;
            liveElapsed = 0;
          }
          if (liveProg) liveProg.style.width = Math.min(100, liveElapsed / liveSpeed * 100) + '%';
        }
        window.requestAnimationFrame(liveTick);
      };
      window.requestAnimationFrame(liveTick);
    } else if (liveProg) {
      liveProg.style.display = 'none';
    }
  }

  /* ---------- CTA magnétique ---------- */
  var magZone = header.querySelector('[data-jmh-magnetic]');
  if (magZone && !reduceMotion && window.matchMedia('(pointer: fine)').matches) {
    var magBtn = magZone.firstElementChild;
    magZone.addEventListener('mousemove', function (e) {
      var r = magZone.getBoundingClientRect();
      var dx = e.clientX - (r.left + r.width / 2);
      var dy = e.clientY - (r.top + r.height / 2);
      magBtn.style.transition = 'transform .1s ease';
      magBtn.style.transform = 'translate(' + dx * 0.3 + 'px,' + dy * 0.3 + 'px)';
    });
    magZone.addEventListener('mouseleave', function () {
      magBtn.style.transition = 'transform .4s cubic-bezier(.34,1.56,.64,1)';
      magBtn.style.transform = 'translate(0,0)';
    });
  }

  /* ---------- Sticky verre dépoli ---------- */
  var stickyMode = header.getAttribute('data-sticky');
  if (stickyMode && stickyMode !== 'none') {
    var wrapper = header.closest('.shopify-section');
    if (wrapper) {
      wrapper.style.position = 'sticky';
      wrapper.style.top = '0';
      wrapper.style.zIndex = '40';
      wrapper.classList.add('jmh-sticky-wrap');
    }
    header.classList.add('has-sticky');
    /* Hystérésis : on exige un vrai mouvement (60 px vers le bas, 20 px vers
       le haut) avant de basculer, et tout passe par requestAnimationFrame.
       Sans ça, les pages à défilement scrubé (héro vidéo de la page
       Qui sommes-nous) faisaient clignoter le header à chaque micro-variation. */
    var lastY = window.scrollY;
    var accum = 0;
    var lastDir = 0;
    var ticking = false;
    function onScrollFrame() {
      ticking = false;
      var y = window.scrollY;
      var dy = y - lastY;
      lastY = y;
      header.classList.toggle('is-stuck', y > 40);
      if (stickyMode !== 'on-scroll-up') return;
      if (mega && mega.classList.contains('is-open')) { header.classList.remove('is-hidden'); return; }
      var dir = dy > 0 ? 1 : (dy < 0 ? -1 : 0);
      if (dir !== 0) {
        if (dir !== lastDir) { accum = 0; lastDir = dir; }
        accum += Math.abs(dy);
      }
      if (y < 320) { header.classList.remove('is-hidden'); return; }
      if (dir === 1 && accum > 60) header.classList.add('is-hidden');
      else if (dir === -1 && accum > 20) header.classList.remove('is-hidden');
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; window.requestAnimationFrame(onScrollFrame); }
    }, { passive: true });
  }

  /* ---------- Fermer le panneau "Nous appeler" au clic dehors ---------- */
  var call = header.querySelector('.jmh-call');
  if (call) {
    document.addEventListener('click', function (e) {
      if (call.hasAttribute('open') && !call.contains(e.target)) call.removeAttribute('open');
    });
  }

  /* ---------- Drawer mobile ---------- */
  var drawer = document.querySelector('.jmh-drawer');
  var burger = header.querySelector('[data-jmh-burger]');
  if (drawer && burger) {
    function setDrawer(open) {
      drawer.classList.toggle('is-open', open);
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.body.style.overflow = open ? 'hidden' : '';
    }
    burger.addEventListener('click', function () { setDrawer(!drawer.classList.contains('is-open')); });
    drawer.querySelector('.jmh-drawer__overlay').addEventListener('click', function () { setDrawer(false); });
    var closeBtn = drawer.querySelector('.jmh-drawer__close');
    if (closeBtn) closeBtn.addEventListener('click', function () { setDrawer(false); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') setDrawer(false); });
  }

  }

  initJmhHeader();
  document.addEventListener('DOMContentLoaded', initJmhHeader);
  document.addEventListener('shopify:section:load', function () { window.setTimeout(initJmhHeader, 0); });
})();
